/*
More infos on CSS module values:
https://github.com/css-modules/css-modules/blob/master/docs/values-variables.md
*/

@use 'sass:meta';
@use './_cluster-constants.scss' as cluster;

:export {
  @each $name, $value in meta.module-variables('cluster') {
    #{$name}: #{$value};
  }
}
